import { Box, TextField, Typography } from '@mui/material'
import { ChangeEvent, useEffect } from 'react'
import BasicContainer from '../../components/BasicContainer'
import ButtonsGroup from '../../components/ButtonsGroup'
import CardTAG from '../../components/CardTAG'
import Dropdown from '../../components/Dropdown'
import selectOptions from '../../constants/selectOptions'
import { useDispatch, useSelector } from 'react-redux'
import appConfigSelector from '../../store/appConfig/appConfigSelector'
import { AppDispatch } from '../../store'
import { archivePageViewChange, update } from '../../store/appConfig/appConfigSlice'
import LabelErrorTAG from '../../components/LabelErrorTAG'

interface IFilterPart {
  jumpToWatchValue: string
  sortByWatchValue: string
  control: any
  handleSearchChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  searchValue: string
}

const FilterPart = ({
  jumpToWatchValue,
  control,
  sortByWatchValue,
  searchValue,
  handleSearchChange,
}: IFilterPart) => {
  const viewType = useSelector(appConfigSelector.archivePageView)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (jumpToWatchValue) {
      const element: HTMLElement | null = document.querySelector(`#${jumpToWatchValue}`)
      if (element) {
        const scrollEl = document.querySelector('.t-page-body')
        if (scrollEl) {
          scrollEl?.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 122,
          })
        }
      }
    }
  }, [jumpToWatchValue])

  useEffect(() => {
    const viewTypeLocalStorageItem = localStorage.getItem('viewType')
    const viewTypeObject = viewTypeLocalStorageItem && JSON.parse(viewTypeLocalStorageItem)
    dispatch(update(viewTypeObject))
  }, [])

  return (
    <>
      <CardTAG title={'Filter'} className='t-filter-card' closable={false}>
        <div className='t-filter-car-row t-hbox t-justify-content-between'>
          <Dropdown
            control={control}
            label='Sort by'
            options={selectOptions.filterCasesBy}
            fieldName='sortBy'
            selectedValue={sortByWatchValue}
          />
          <Box>
            <Typography sx={{ typography: 'labelBold', marginBottom: '.7rem' }}>View as</Typography>
            <ButtonsGroup
              selectedValue={viewType}
              firstButtonLabel='Tiles'
              secondButtonLabel='List'
              firstButtonClickHandler={() => {
                dispatch(archivePageViewChange('box'))
              }}
              secondButtonClickHandler={() => {
                dispatch(archivePageViewChange('list'))
              }}
            />
          </Box>
        </div>
        <div className='t-field t-vbox'>
          <LabelErrorTAG label='Search' />
          <TextField placeholder='Search' value={searchValue} onChange={handleSearchChange} />
        </div>
      </CardTAG>
      <BasicContainer>
        <Dropdown
          label='Jump to section'
          control={control}
          fieldName='jumpTo'
          selectedValue={jumpToWatchValue}
          options={selectOptions.archiveJumpToSection}
          placeholder='Select a Section'
        />
      </BasicContainer>
    </>
  )
}

export default FilterPart
